import { render } from "./tabOne.vue?vue&type=template&id=204887ce"
import script from "./tabOne.vue?vue&type=script&lang=js"
export * from "./tabOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__